import React, { Fragment, useRef, useState } from "react";
import { callApi } from "../../helpers";
import DetailsCall from "../DetailsCall/DetailsCall";
import classes from "./Call.module.sass";

function Call(props) {
  const { date, weekDay, time, startedAt, duration, durationLabel, title, icon, url } =
    props;

  const [showDetailCall, setShowDetailCall] = useState(false);

  const getMainContent = () => {
    callApi(url, "GET", "json", (data) => {
      setContent(data);
    });
  };

  const clickOnTop = () => {
    if (showDetailCall) {
      setShowDetailCall(false);
    } else {
      setShowDetailCall(true);
    }
  };

  return (
    <div
      className={`${classes.bgGradient} ${classes.bgGradientClose} ${classes.call}`}
    >
      <div className="row" onClick={clickOnTop}>
        <div className="col col-lg-10 d-flex align-items-center">
          <div
            className={`d-inline ps-4 ${classes.textSecondary} me-2`}
            dangerouslySetInnerHTML={{ __html: icon }}
          />
          <div className={`d-inline ${classes.label}`}>{title}</div>
          {
            duration &&
            <div className="durationContainer ms-auto d-flex flex-column align-items-end">
              <div className={`${classes.durationLabel}`}>{durationLabel}</div>
              <div className={`${classes.duration}`}>{duration}</div>
            </div>
          }
        </div>
        <div className={`col ${classes.dateTime}`}>
          <div className={classes.time}>{startedAt === "--" ? time : startedAt}</div>
          <div className={classes.date}>{date}</div>
        </div>
      </div>
      <div className="main-content">
        {showDetailCall ? <DetailsCall callURL={url} insideBox={true} /> : null}
      </div>
    </div>
  );
}

export default Call;
